import {createApp} from 'vue'
import GroupPost from './GroupPost'

const el = '.kb-component--group-post'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((GroupPostDOM)=>{
            const props = {
                result: GroupPostDOM.dataset.result ? JSON.parse(GroupPostDOM.dataset.result) : {},
                comments: GroupPostDOM.dataset.comments ? JSON.parse(GroupPostDOM.dataset.comments) : null,
                isFrivilligContext: GroupPostDOM.dataset.isFrivilligContext,
                groupId: GroupPostDOM.dataset.groupId
            }
            const component = createApp(GroupPost, props).use(Store)
            component.mount(GroupPostDOM)
        })
    }
}